export default "__VITE_ASSET__a4e46124__"